export default "__VITE_ASSET__Coi0zP4w__"